import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemIcon,
} from "@mui/material";
import { AccountCircle, Logout as LogoutIcon } from "@mui/icons-material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import KeyIcon from "@mui/icons-material/Key";
import { useSelector, useDispatch } from "react-redux";
import logoImage from "../assets/images/login/logoT.png";
import { logout } from "../store/userSlice";
import { useApiUtil } from "../utils/apiUtil";
import PasswordPopup from "../comm/passwordPopup/PasswordPopup";
import { goLogin } from "../utils/navigation";

const Header = ({ menuData, selectedMenuId, onMenuClick }) => {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.user.username);
  const userInfo = useSelector((state) => state.user.userInfo);
  const { gfnCallApi } = useApiUtil();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userName, setUserName] = useState(username);
  const [deptName, setDeptName] = useState(username);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [openPasswordPopup, setOpenPasswordPopup] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) document.documentElement.requestFullscreen();
    else document.exitFullscreen();
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    handleMenuClose();
    try {
      // 토큰이 유효한 동안 서버 로그아웃을 먼저 요청
      await gfnCallApi({ url: "logout", method: "POST", data: {}, showMsg: false });
    } finally {
      // 서버 로그아웃이 실패해도 클라이언트 인증 상태는 종료
      localStorage.removeItem("ACCESS_TOKEN");
      sessionStorage.removeItem("ACCESS_TOKEN");
      dispatch(logout());
      goLogin();
    }
  };

  useEffect(() => {
    setUserName(username);
    setDeptName(userInfo?.DEPT_KORN_NM);
  }, [username, userInfo]);

  useEffect(() => {
    const handleFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  return (
    <>
      <AppBar position="static" sx={{ background: "#003461", height: 60, justifyContent: "center" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", minHeight: 48 }}>
          <Box className="logo" sx={{ width: 200, height: 35, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img src={logoImage} alt="logo" style={{ height: "auto", width: "auto", maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }} />
          </Box>

          <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "left", marginLeft: "30px", gap: 2 }}>
            {menuData.map((item) => {
              const isSelected = selectedMenuId === item.MODULE_CD;
              return (
                <Typography
                  key={item.MENU_ID}
                  variant="button"
                  onClick={() => onMenuClick(item)}
                  sx={{
                    px: 2, py: "4px", lineHeight: "1.8", borderRadius: 1, cursor: "pointer",
                    color: isSelected ? "#fff" : "#cccccc",
                    backgroundColor: isSelected ? "#004C8F" : "transparent",
                    transition: "color 0.3s", "&:hover": { color: "white" },
                  }}
                >
                  {item.MENU_NM}
                </Typography>
              );
            })}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)", whiteSpace: "nowrap", paddingRight: "15px" }}>
              <Box component="span" sx={{ fontWeight: 600 }}>{deptName} {userName}</Box> 님
            </Typography>

            <Tooltip title={isFullscreen ? "전체 화면 종료" : "전체 화면"}>
              <IconButton color="inherit" onClick={toggleFullscreen}>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>

            <Box sx={{ width: "1px", height: 16, mx: 1, backgroundColor: "rgba(255,255,255,0.4)" }} />

            <Tooltip title="계정">
              <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} color="inherit" sx={{ paddingLeft: 0 }}>
                <AccountCircle sx={{ width: 28, height: 28 }} />
              </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem disabled>{userName} 님</MenuItem>
              <MenuItem onClick={() => { handleMenuClose(); setOpenPasswordPopup(true); }}>
                <ListItemIcon><KeyIcon fontSize="small" /></ListItemIcon>
                비밀번호 변경
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                로그아웃
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <PasswordPopup open={openPasswordPopup} onClose={() => setOpenPasswordPopup(false)} onSubmit={handleLogout} />
    </>
  );
};

export default Header;

// 기존 소켓 연결·알림 포함 상단바
// -----------------------------------------------------------------------------
// import React, { useState, useEffect, useRef } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Box,
//   IconButton,
//   Menu,
//   MenuItem,
//   Avatar,
//   Badge,
//   InputBase,
//   Tooltip,
//   Tabs,
//   Tab,
//   Popover,
//   ListItemIcon,
//   Divider,
//   Stack,
// } from "@mui/material";
// 
// import { styled, alpha } from "@mui/material/styles";
// import {
//   Search as SearchIcon,
//   Notifications as NotificationsIcon,
//   AccountCircle,
//   Logout as LogoutIcon,
//   MoreVert as MoreIcon,
//   Settings as SettingsIcon,
//   Language as LanguageIcon,
// } from "@mui/icons-material";
// import { useSelector, useDispatch } from "react-redux";
// import logoImage from "../assets/images/login/logoT.png";
// import FullscreenIcon from "@mui/icons-material/Fullscreen";
// import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
// import KeyIcon from "@mui/icons-material/Key";
// import LinkIcon from "@mui/icons-material/Link";
// import LinkOffIcon from "@mui/icons-material/LinkOff";
// import CheckIcon from "@mui/icons-material/Check";
// import DeleteIcon from "@mui/icons-material/Delete";
// 
// import PeopleIcon from "@mui/icons-material/People";
// 
// import {
//   logout
// } from "../store/userSlice";
// 
// import { useApiUtil } from "../utils/apiUtil";
// import PasswordPopup from "../comm/passwordPopup/PasswordPopup";
// import SocketListPopup from "../comm/socketListPopup/SocketListPopup";
// import SocketManager from "@/utils/SocketManager";
// 
// const Search = styled("div")(({ theme }) => ({
//   position: "relative",
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.white, 0.15),
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.common.white, 0.25),
//   },
//   marginRight: theme.spacing(2),
//   marginLeft: 0,
//   width: "100%",
//   [theme.breakpoints.up("sm")]: {
//     marginLeft: theme.spacing(3),
//     width: "auto",
//   },
// }));
// 
// const SearchIconWrapper = styled("div")(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: "100%",
//   position: "absolute",
//   pointerEvents: "none",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// }));
// 
// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: "inherit",
//   "& .MuiInputBase-input": {
//     padding: theme.spacing(1, 1, 1, 0),
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create("width"),
//     width: "100%",
//     [theme.breakpoints.up("md")]: {
//       width: "20ch",
//     },
//   },
// }));
// 
// const Header = ({ menuData, selectedMenuId, onMenuClick }) => {
// 
//   const socketRef = useRef(null);
// 
//   const [socketConnected, setSocketConnected] = useState(false);
//   const [socketAnchorEl, setSocketAnchorEl] = useState(null);
//   const [socketConnCount, setSocketConnCount] = useState(0);
// 
//   const socketOpen = Boolean(socketAnchorEl);  
// 
//   const dispatch = useDispatch();
//   const userId = useSelector((state) => state.user.userId);
//   const token = useSelector((state) => state.user.token);
//   const username = useSelector((state) => state.user.username);
//   const userInfo = useSelector((state) => state.user.userInfo);
// 
//   const { gfnCallApi } = useApiUtil();
// 
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [langAnchorEl, setLangAnchorEl] = useState(null);
// 
//   const [userName, setUserName] = useState(username);
//   const [deptName, setDeptName] = useState(username);
// 
//   // Notification
//   const [notifAnchorEl, setNotifAnchorEl] = useState(null);
//   const [tabIndex, setTabIndex] = useState(0);
// 
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [openPasswordPopup, setOpenPasswordPopup] = useState(false);
//   const [openSocketListPopup, setOpenSocketListPopup] = useState(false);
//   const [socketConnectList, setSocketConnectList] = useState([]);
// 
//   const isLogoutRef = useRef(false);
// 
//   const generateNotificationId = () =>
//     `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
// 
//   const [notifications, setNotifications] = useState({
//     system: [
//     ],
//     personal: [
//     ],
//   });
// 
//   const alramCount =
//     notifications.system.length + notifications.personal.length;  
// 
//   const toggleFullscreen = () => {
//     if (!document.fullscreenElement) {
//       document.documentElement.requestFullscreen();
//     } else {
//       document.exitFullscreen();
//     }
//   };
// 
//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
// 
//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };
// 
// 
//   const handleSocketMenuClose = () => {
//     setSocketAnchorEl(null);
//   };
// 
//   const handleLangOpen = (event) => {
//     setLangAnchorEl(event.currentTarget);
//   };
// 
//   const handleLangClose = () => {
//     setLangAnchorEl(null);
//   };
// 
//   const socketConnect = async () => {
//     await socketRef.current.WebSocketEvent();
// 
//   };  
// 
//   const handleSocketRryOpen = async (chkToken) => {
//     socketRef.current = new SocketManager(
//       userId,
//       userName,
//       chkToken,
//       userId, // sessionKey
//       {
//         onOpen: () => {
//           console.log("✅ WebSocket 연결됨");
//           openMessages();
//         },
//         onMessage: (action, msgId, message) => {
//           if (isLogoutRef.current) return;
//           setMessages(action, msgId, message);
//           //setMessages(prev => [...prev, message]);
//         },
//         onClose: () => {
//           setSocketConnected(false);
//         },
//         onError: (err) => {
//         }
//       }      
//     );
//     socketConnect();
//   };
// 
//   const openMessages = () => {
//     isLogoutRef.current = false;
//     setSocketConnected(true);
//     /*
//     const data = {
//       "sendmsg" : "보낸다",
//     }
//     socketRef.current.sendUserMessage("send", {}, data, userId)
//     */
//   };   
// 
//   /*
//     메시지 수신후 알림에 추가
//   */
//   const addNotification = (notification) => {
//     const { type, ...payload } = notification;
// 
//     const id = generateNotificationId();
// 
//     setNotifications((prev) => {
//       return {
//         ...prev,
//         [type]: [
//           {
//             ...payload,
//             id,
//           },
//           ...prev[type],
//         ],
//       };
//     });
//   };
// 
//   /*
//     메시지 발송
//   */
//   const sendUserMessage = (type, users, title, message) => {
//     const data = {
//       message: message,
//       sendUser: userName,
//       title: title,
//       timestamp: Date.now(),
//       sendType: (!users || users.length === 0 ? "ALL" : "USER"),
//     }
//     socketRef.current.sendUserMessage("publish", "send", {}, data, users) ;    
//   };
// 
//   const formatTimeAgo = (timestamp) => {
//     if(!timestamp) return "";
//     const diff = Date.now() - timestamp;
// 
//     const sec = Math.floor(diff / 1000);
//     if (sec < 60) return "방금";
// 
//     const min = Math.floor(sec / 60);
//     if (min < 60) return `${min}분 전`;
// 
//     const hour = Math.floor(min / 60);
//     if (hour < 24) return `${hour}시간 전`;
// 
//     const day = Math.floor(hour / 24);
//     return `${day}일 전`;
//   };  
//   /*
//     소켓으로부터 메시지 수신
//   */
//   const setMessages = (action, msgId, message) => {
//     console.log("Message 도착", action, msgId, message);
//     switch(action) {
//       case "totalCount" :
//           setTimeout(() => {
//             setSocketConnCount(Number(message[0].totalCount));  
//           }, 10);
//           
//         break;
//       case "publish" :
//           const msg = message;
//           switch(msgId) {
//             case "allroom" :
//                 setSocketConnectList(msg);
//                 setOpenSocketListPopup(true);                
//                 break;
//             case "data" :
// 
//                 const raw = msg[0].data;
// 
//                 const notification = {
//                   type: raw.sendType === "ALL" ? "system" : "personal",
//                   title: raw.title,
//                   message: raw.message,
//                   sendUser: raw.sendUser,
//                   createdAt: raw.timestamp,
//                 };
//                 addNotification(notification);            
//                 break;
//             default:
//           }
//         break;
//       default:
//     }
//   };    
// 
//   useEffect(() => {
//     const chkToken = token || localStorage.getItem("ACCESS_TOKEN");
//     if (!chkToken || !userId) return;
// 
//     handleSocketRryOpen(chkToken);
// 
//     return () => {
//       socketRef.current?.webSocketObj?.close();
//       socketRef.current = null;
//     };
//   }, [token, userId]);
// 
//   const handleLogout = async () => {
//     handleMenuClose();
//     localStorage.setItem("ACCESS_TOKEN", null);
//     const result = await gfnCallApi({
//       url: "logout",
//       method: "POST",
//       data: {
//       }
//     });
//     isLogoutRef.current = true;
//     socketRef.current?.webSocketObj?.close();
//     socketRef.current = null;
// 
//     // 상태 초기화
//     setSocketConnected(false);
//     setSocketConnCount(0);
//     setSocketAnchorEl(null);
//         
//     dispatch(logout());    
// 
//     //window.location.href = "/login";
//   };
// 
//   const handleNotifClick = (event) => {
//     setNotifAnchorEl(event.currentTarget);
//   };
// 
//   const handleNotifClose = () => {
//     setNotifAnchorEl(null);
//   };
// 
//   const handleOpenPasswordPopup = () => {
//     handleMenuClose();
//     setOpenPasswordPopup(true);
//   };  
// 
// 
//   const handleSocketPopupOpen = (event) => {
//     // 전체 리스트 조회
//     const data = {
//     }
//     socketRef.current.sendUserMessage("viewerlist", "send", {}, data) ;
//     handleSocketMenuClose();
//     // 리스트 조회
//     //handleSocketMenuClose();
//     //setOpenSocketListPopup(true);
//   };
// 
//   const handleRemoveNotification = (type, id) => {
//     setNotifications((prev) => ({
//       ...prev,
//       [type]: prev[type].filter((n) => n.id !== id),
//     }));
//   };
// 
//   const notifOpen = Boolean(notifAnchorEl);
// 
//   const NotificationItem = ({ item, onConfirm }) => {
//   return (
//     <Box
//       sx={{
//         p: 1.5,
//         mb: 1,
//         borderRadius: 2,
//         border: "1px solid",
//         borderColor: "divider",
//         "&:hover": {
//           backgroundColor: "action.hover",
//         },
//       }}
//     >
//       <Stack spacing={0.5}>
//         <Stack direction="row" justifyContent="space-between" alignItems="center">
//           <Stack direction="row" spacing={0.5} alignItems="center">
//             <Typography fontWeight={600} fontSize={14}>
//               {item.title}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               ({item.sendUser})
//             </Typography>
//           </Stack>
// 
//           <Typography variant="caption" color="text.secondary">
//             {formatTimeAgo(item.createdAt)}
//           </Typography>
//         </Stack>
// 
//         <Typography variant="body2">{item.message}</Typography>
// 
//         <Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}>
//           <IconButton size="small" color="error" onClick={onConfirm}>
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Stack>
//       </Stack>
//     </Box>
//   );
//   };  
// 
//   useEffect(() => {
//     setUserName(username);
//     setDeptName(userInfo?.DEPT_KORN_NM);
//   }, [username]);  
// 
// 
//   // F11 / ESC 등으로 변경될 경우 상태 동기화
//   useEffect(() => {
//     const handleFullscreenChange = () => {
//       setIsFullscreen(!!document.fullscreenElement);
//     };
// 
//     document.addEventListener("fullscreenchange", handleFullscreenChange);
//     return () => {
//       document.removeEventListener("fullscreenchange", handleFullscreenChange);
//     };
//   }, []);
// 
//   return (
//     <>
//     <AppBar
//       position="static"
//       sx={{
//         background: "#003461",//"linear-gradient(90deg, rgb(15 31 74), rgb(18 71 139), rgb(27 117 201))",        
//         height: 60,
//         justifyContent: "center",
//       }}
//     >
//       <Toolbar
//         sx={{ display: "flex", justifyContent: "space-between", minHeight: 48 }}
//       >
//         <Box
//           className="logo"
//           sx={{
//             width: 200,
//             height: 35,
//             ml: 0,
//             display: "flex",
//             alignItems: "center",     // vertical center
//             justifyContent: "center", // horizontal center            
//           }}
//         >
//           <img
//             src={logoImage}          
//             alt="logo"
//             style={{ height: "auto", width:"auto", maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
//           />
//         </Box>
// 
//         <Box
//           sx={{
//             display: "flex",
//             flexGrow: 1,
//             justifyContent: "left",
//             marginLeft: "30px",
//             gap: 2,
//           }}
//         >
//           {menuData.map((item) => {
//             const isSelected = selectedMenuId === item.MODULE_CD;
//             return (
//               <Typography
//                 key={item.MENU_ID}
//                 variant="button"
//                 onClick={() => onMenuClick(item)}
//                 sx={{
//                   position: "relative",
//                   px: 2,
//                   py: "4px",          
//                   lineHeight: "1.8",  
//                   minHeight: "auto",  
//                   borderRadius: 1,
//                   cursor: "pointer",
//                   color: isSelected ? "#fff" : "#cccccc",
//                   backgroundColor: isSelected ? "#004C8F" : "transparent",
//                   transition: "color 0.3s",
//                   "&::after": {
//                     content: '""',
//                     position: "absolute",
//                     bottom: 0,
//                     left: 8,
//                     right: 8,
//                     height: "2px",
//                     backgroundColor: "yellow",
//                     transform: isSelected ? "scaleX(0)" : "scaleX(0)",
//                     transformOrigin: "center",
//                     transition: "transform 0.3s ease",
//                   },
//                   "&:hover": {
//                     color: "white",
//                   },
//                   "&:hover::after": {
//                     transform: "scaleX(1)",
//                   },
//                 }}
//               >
//                 {item.MENU_NM}
//               </Typography>
//             );
//           })}
//         </Box>
// 
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           {/*}
//           <Tooltip title="언어 변경">
//             <IconButton color="inherit" onClick={handleLangOpen}>
//               <LanguageIcon />
//             </IconButton>
//           </Tooltip>
//           <Menu
//             anchorEl={langAnchorEl}
//             open={Boolean(langAnchorEl)}
//             onClose={handleLangClose}
//           >
//             <MenuItem onClick={handleLangClose}>简体中文</MenuItem>
//             <MenuItem onClick={handleLangClose}>English</MenuItem>
//           </Menu>
//           {*/}
// 
//           <Typography
//           variant="body2"
//           sx={{
//             color: "rgba(255,255,255,0.85)",
//             whiteSpace: "nowrap",
//             paddingRight: "15px",
//           }}
//         >
//           <Box component="span" sx={{ fontWeight: 600 }}>
//             {deptName} {userName}
//           </Box>
//           님.
//         </Typography>        
// 
//           <Tooltip title={isFullscreen ? "화면최대화 종료" : "화면최대화"}>
//             <IconButton color="inherit" onClick={toggleFullscreen}>
//               {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
//             </IconButton>
//           </Tooltip>
// 
//           <Tooltip title={socketConnected ? "Socket 연결됨" : "Socket 연결 끊김"}>
//             <IconButton
//               color="inherit"
//               onClick={(e) => setSocketAnchorEl(e.currentTarget)}
//             >
//               <Badge
//                 badgeContent={socketConnCount}
//                 color="primary"
//                 showZero
//                 invisible={!socketConnected}
//               >
//                 {socketConnected ? (
//                   <LinkIcon sx={{ color: "#22c55e" }} /> 
//                 ) : (
//                   <LinkOffIcon sx={{ color: "#ef4444" }} />
//                 )}
//               </Badge>
//             </IconButton>
//           </Tooltip>          
//           <Menu
//             anchorEl={socketAnchorEl}
//             open={Boolean(socketAnchorEl)}
//             onClose={handleSocketMenuClose}
//           >
//             <MenuItem disabled>전체 {socketConnCount} 명 접속중</MenuItem>
//             {!socketConnected && (
//               <MenuItem onClick={handleSocketRryOpen}>
//                 메시지 발송
//               </MenuItem>
//             )}
//             <MenuItem onClick={handleSocketPopupOpen}>
//               메시지 발송
//             </MenuItem>            
//           </Menu>          
// 
//           {/* Notification with Tabs */}
//           <Tooltip title="알림">
//             <IconButton color="inherit" onClick={handleNotifClick} sx={{ paddingRight: 0}}>
//               <Badge badgeContent={alramCount} invisible={alramCount===0} color="error">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>
//           </Tooltip>
// 
//           <Popover
//             open={notifOpen}
//             anchorEl={notifAnchorEl}
//             onClose={handleNotifClose}
//             anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//             transformOrigin={{ vertical: "top", horizontal: "right" }}
//             PaperProps={{
//               sx: {
//                 width: 360,
//                 borderRadius: 3,
//                 boxShadow: 8,
//                 overflow: "hidden",
//               },
//             }}
//           >
//             {/* Header */}
//             <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider" }}>
//               <Typography fontWeight={600}>알림</Typography>
//             </Box>
// 
//             {/* Tabs */}
//             <Tabs
//               value={tabIndex}
//               onChange={(e, v) => setTabIndex(v)}
//               variant="fullWidth"
//             >
//               <Tab label={`시스템 (${notifications.system.length})`} />
//               <Tab label={`내 메시지 (${notifications.personal.length})`} />
//             </Tabs>
// 
//             {/* Content */}
//             <Box sx={{ maxHeight: 320, overflowY: "auto", p: 1 }}>
//               {(tabIndex === 0 ? notifications.system : notifications.personal).length === 0 ? (
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   align="center"
//                   sx={{ mt: 4 }}
//                 >
//                   알림이 없습니다
//                 </Typography>
//               ) : (
//                 (tabIndex === 0 ? notifications.system : notifications.personal).map(
//                   (item) => (
//                     <NotificationItem
//                       key={item.id}
//                       item={item}
//                       onConfirm={() =>
//                         handleRemoveNotification(tabIndex === 0 ? "system" : "personal", item.id)
//                       }
//                     />
//                   )
//                 )
//               )}
//             </Box>
//           </Popover>
// 
//           <Box
//             sx={{
//               width: "1px",
//               height: 16,
//               mx: 1,
//               backgroundColor: "rgba(255,255,255,0.4)",
//             }}
//           />
// 
//           <Tooltip title="계정">
//             <IconButton onClick={handleMenuOpen} color="inherit" sx={{ paddingLeft: 0}}>
//                 <AccountCircle sx={{ width: 28, height: 28 }}/>
//               {/*<Avatar sx={{ width: 28, height: 28 }}>
//                 <AccountCircle />
//               </Avatar>*/}
//             </IconButton>
//           </Tooltip>
//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleMenuClose}
//           >
//             <MenuItem disabled>{userName} 님</MenuItem>
//             <MenuItem onClick={handleOpenPasswordPopup}>
//               <ListItemIcon>
//                 <KeyIcon fontSize="small" />
//               </ListItemIcon>
//               비밀번호 변경
//             </MenuItem>            
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <LogoutIcon fontSize="small" />
//               </ListItemIcon>
//               로그아웃
//             </MenuItem>
//           </Menu>
//           {/*}
//           <IconButton color="inherit">
//             <MoreIcon />
//           </IconButton>
//           {*/}
//         </Box>
//       </Toolbar>
//     </AppBar>
// 
//     <PasswordPopup
//       open={openPasswordPopup}
//       onClose={() => setOpenPasswordPopup(false)}
//     />    
//     <SocketListPopup
//       open={openSocketListPopup}
//       sendUserMessage={sendUserMessage}
//       socketConnectList={socketConnectList}
//       onClose={() => setOpenSocketListPopup(false)}
//     />        
//     </>
//   );
// };
// 
// export default Header;
// 
